export const ANALYTICS_SOURCE = 'bulkSpacePermissionsScreen';
